import Alert from "../models/Alert"

const state = {
    login_alerts: [],
    landing_alerts: [],
};

const mutations = {
    'SET_LOGIN_ALERTS'(state, alerts) {
        state.login_alerts = alerts.map(item => {
            state.login_alerts.forEach(alert => {
                if(alert.id === item.id) {
                    item.is_active = alert.is_active
                }
            })
            return item
        })
    },
    'SET_LANDING_ALERTS'(state, alerts) {
        state.landing_alerts = alerts.map(item => {
            state.landing_alerts.forEach(alert => {
                if(alert.id === item.id) {
                    item.is_active = alert.is_active
                }
            })
            return item
        })
    },
    'SET_ALERT_SEEN'(state, alert) {
        state.landing_alerts.forEach(item => {
            if(item.id === alert.id) {
                item.is_active = false
            }
        })

        state.login_alerts.forEach(item => {
            if(item.id === alert.id) {
                item.is_active = false
            }
        })
    }
};

const actions = {
    async set_login_alerts({commit}) {
        try {
            let alerts = await Alert.onLogin()
            commit('SET_LOGIN_ALERTS', alerts)
            return alerts
        } catch (e) {
            return e
        }
    },
    async set_landing_alerts({commit}) {
        try {
            let alerts = await Alert.onLanding()
            commit('SET_LANDING_ALERTS', alerts)
            return alerts
        } catch (e) {
            return e
        }
    },
    set_alert_seen({commit}, alert) {
        commit('SET_ALERT_SEEN', alert)
    }
};

const getters = {
    landing_alerts: state => {
        return state.landing_alerts
    },
    login_alerts: state => {
        return state.login_alerts
    },
};

export default {
    state,
    mutations,
    actions,
    getters
};
